export default {
  meta: {
    title: '开发部绩效报表',
    url: '/storemanage/devdptkpireport' // 埋点用，记录所属模块
  },
};
